import React, { PureComponent } from "react";
import {
  BarChart,
  Bar,
  Cell,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";
import { HomepageContext } from "context/homepageProvider";

export default class StackedBarChart extends PureComponent {
  render() {
    const data = [
      {
        name: "ปัญหาเกี่ยวกับเครื่องจักร",
        แก้ผ่านโทรศัพท์: this.context.topClaimList?.top_claim?.mobile[3].y,
        แก้หน้างาน: this.context.topClaimList?.top_claim?.on_site[3].y,
      },
      {
        name: "ปัญหาเกี่ยวกับอะไหล่",
        แก้ผ่านโทรศัพท์: this.context.topClaimList?.top_claim?.mobile[2].y,
        แก้หน้างาน: this.context.topClaimList?.top_claim?.on_site[2].y,
      },
      {
        name: "ปัญหาเกี่ยวกับการใช้งาน",
        แก้ผ่านโทรศัพท์: this.context.topClaimList?.top_claim?.mobile[1].y,
        แก้หน้างาน: this.context.topClaimList?.top_claim?.on_site[1].y,
      },
      {
        name: "ปัญหาอื่นๆ",
        แก้ผ่านโทรศัพท์: this.context.topClaimList?.top_claim?.mobile[0].y,
        แก้หน้างาน: this.context.topClaimList?.top_claim?.on_site[0].y,
      },
    ];

    return (
      <div
        style={{
          width: "100%",
          height: 450,
          backgroundColor: "white",
          marginTop: "0.5%",
        }}
      >
        <ResponsiveContainer>
          <BarChart
            width={500}
            height={300}
            data={data}
            margin={{
              top: 20,
              right: 30,
              left: 20,
              bottom: 5,
            }}
          >
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="name" />
            <YAxis />
            <Tooltip />
            <Legend />
            <Bar
              dataKey="แก้หน้างาน"
              barSize={100}
              stackId="a"
              fill="#DD4A48"
            />
            <Bar
              dataKey="แก้ผ่านโทรศัพท์"
              barSize={100}
              stackId="a"
              fill="#344CB7"
            />
          </BarChart>
        </ResponsiveContainer>
      </div>
    );
  }
}

StackedBarChart.contextType = HomepageContext;
